import { Stack } from '@mui/material';

import { RecordingFeedbackBonusBanner } from '@/features/recordingFeedbackBonus';

import { MobileNavigation } from '@/shared/ui/MobileNavigation';

import { RecordingProfile } from './RecordingProfile';
import { useRecordingSidebarNavigation } from './useRecordingSidebarNavigation';

type Props = {
  isAuthenticated?: boolean;
  isOpen: boolean;
  onToggle: () => void;
};

export const RecordingMobileSidebar = ({ isAuthenticated = true, isOpen, onToggle }: Props) => {
  const { bottomNavigation, isAccountActive, mainNavigation } = useRecordingSidebarNavigation({ onAction: onToggle });

  return (
    <MobileNavigation
      profileContainer={
        <RecordingProfile active={isAccountActive} isAuthenticated={isAuthenticated} variant="outlined" />
      }
      bottomNavigation={bottomNavigation}
      mainNavigation={mainNavigation}
      open={isOpen}
      onClose={onToggle}
      onOpen={onToggle}
    >
      {isOpen && isAuthenticated && (
        <Stack marginTop={16}>
          <RecordingFeedbackBonusBanner />
        </Stack>
      )}
    </MobileNavigation>
  );
};
